import styled from 'styled-components';

const S = {};

S.RegisterWizardForm = styled.div`
    width: 100%;
    background-color: ${({theme: {$signUpFormBackgroundColor}}) => $signUpFormBackgroundColor};
`;

S.RegisterHeader = styled.div`
    position: relative;
    background-color: ${({theme:{$signUpHeaderBackgroundColor}}) => $signUpHeaderBackgroundColor};
    height: 3rem; 
    line-height: 3rem;
`;

S.RegisterBackButton = styled.a`
    position: absolute;
    margin-left: 1rem;
    padding-top: 0.4rem;
    cursor: pointer;
    height: 100%;
`;

S.RegisterBackButtonIcon = styled.div`
    width: 1.5rem;
    height: 1.5rem;
`;

S.RegisterHeaderText = styled.div`
    text-align: center;
    color: ${({theme:{$signUpHeaderTextColor}}) => $signUpHeaderTextColor};
`;

S.RegisterSuccess = styled.div`
    width: calc(100% - 2rem);
    padding: 1rem;
    text-align: center;
`;

S.RegisterSuccessLabel = styled.span`
    font-size: 1rem;
`;

S.SubmitBtn = styled.div`
    border-radius: 1.75rem;
    background-color: ${({theme:{$registerFormSubmitBtnBgColor}}) => $registerFormSubmitBtnBgColor};
    font-size: 1rem;
    font-weight: 600;
    padding: 0.8333rem;
    margin-bottom: 1.7rem;
    margin-top: 1.8rem;
    color: ${({theme:{$registerFormSubmitBtnColor}}) => $registerFormSubmitBtnColor};
    width: calc(100% - 2rem);
    cursor: pointer;
    text-transform:uppercase;
    box-shadow: 3px 3px 6px #0000004D;
`;


export default S;
